var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForecast({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 52,
    viewBox: "0 0 57 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_478_9096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.9096 15.12H49.1296C47.042 15.12 45.3496 16.8124 45.3496 18.9V47.25C45.3496 49.3376 47.042 51.03 49.1296 51.03H52.9096C54.9972 51.03 56.6896 49.3376 56.6896 47.25V18.9C56.6896 16.8124 54.9972 15.12 52.9096 15.12Z",
    fill: "#027BC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8 28.35H34.02C31.9324 28.35 30.24 30.0424 30.24 32.13V47.25C30.24 49.3376 31.9324 51.03 34.02 51.03H37.8C39.8876 51.03 41.58 49.3376 41.58 47.25V32.13C41.58 30.0424 39.8876 28.35 37.8 28.35Z",
    fill: "#CCE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6791 22.6801H18.8991C16.8115 22.6801 15.1191 24.3724 15.1191 26.4601V47.2501C15.1191 49.3377 16.8115 51.0301 18.8991 51.0301H22.6791C24.7668 51.0301 26.4591 49.3377 26.4591 47.2501V26.4601C26.4591 24.3724 24.7668 22.6801 22.6791 22.6801Z",
    fill: "#027BC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56 34.02H3.78C1.69236 34.02 0 35.7124 0 37.8V47.25C0 49.3376 1.69236 51.03 3.78 51.03H7.56C9.64764 51.03 11.34 49.3376 11.34 47.25V37.8C11.34 35.7124 9.64764 34.02 7.56 34.02Z",
    fill: "#019EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.72073 23.62C5.15073 23.62 5.57073 23.48 5.92073 23.19L20.9307 10.83L34.9007 19.56C35.6507 20.02 36.6207 19.92 37.2307 19.3L50.0707 6.46V8.51C50.0707 9.55 50.9207 10.4 51.9607 10.4C53.0007 10.4 53.8507 9.55 53.8507 8.51V1.89C53.8507 0.85 53.0007 0 51.9607 0H44.4007C43.3607 0 42.5107 0.85 42.5107 1.89C42.5107 2.93 43.3607 3.78 44.4007 3.78H47.4007L35.6307 15.55L21.7907 6.89C21.1007 6.46 20.2107 6.52 19.5907 7.03L3.52073 20.28C2.72073 20.94 2.60073 22.13 3.26073 22.94C3.64073 23.39 4.18073 23.63 4.72073 23.63V23.62Z",
    fill: "#28345A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_478_9096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.69,
    height: 51.02,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForecast);
export default __webpack_public_path__ + "static/media/forecast.af1bd7dfcb2ef638ca5df900bb1c6089.svg";
export { ForwardRef as ReactComponent };